/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { useAssetOptUrl } from "@components/hooks";
import { bgTextShade } from "@components/utils/css.utils";
import { CosmosAssetFragment } from "@cosmos/hygraph-schema";
import { useMemo } from "react";

export type useBgVideoRes = {
	isBgVideo: boolean;
	background?: string;
};

export const useCheckVideo = (mimeType?: string | null): boolean => {
	const isVideo = useMemo(() => mimeType?.startsWith("video/") || false, [mimeType]);

	return isVideo;
};

export const useBgVideo = (asset?: CosmosAssetFragment | null, fullHeight = false): useBgVideoRes => {
	const isBgVideo = useCheckVideo(asset?.mimeType);
	const optUrl = useAssetOptUrl(asset);
	const background = useMemo(() => {
		if (!optUrl || isBgVideo || !fullHeight) return undefined;
		return `${bgTextShade}, url(${optUrl}) center / cover no-repeat`;
	}, [optUrl, isBgVideo, fullHeight]);

	return { isBgVideo, background };
};
